/**
 * A record the API did not find, by entity: `notFound(entity)` sends
 * `<ENTITY>_NOT_FOUND`, one code per entity so the panel's texts agree in
 * gender and case (Russian, Turkish).
 */
export const NOT_FOUND_ENTITIES = [
  'cabinet',
  'config version',
  'configuration',
  'game',
  'invitation',
  'location',
  'member',
  'round',
  'simulation',
  'tenant',
  'user',
] as const

export type NotFoundEntity = (typeof NOT_FOUND_ENTITIES)[number]

export const NOT_FOUND_ERROR_CODES = [
  'CABINET_NOT_FOUND',
  'CONFIG_VERSION_NOT_FOUND',
  'CONFIGURATION_NOT_FOUND',
  'GAME_NOT_FOUND',
  'INVITATION_NOT_FOUND',
  'LOCATION_NOT_FOUND',
  'MEMBER_NOT_FOUND',
  'ROUND_NOT_FOUND',
  'SIMULATION_NOT_FOUND',
  'TENANT_NOT_FOUND',
  'USER_NOT_FOUND',
] as const

/** The code of a missing record of `entity`. */
export function notFoundErrorCode(
  entity: NotFoundEntity,
): (typeof NOT_FOUND_ERROR_CODES)[number] {
  return `${entity.toUpperCase().replace(' ', '_')}_NOT_FOUND` as (typeof NOT_FOUND_ERROR_CODES)[number]
}
